<template>
  <div class="container-fluid page-padding margin_80_55" v-if="tutorialInfo">
    <div class="mt-5">
      <div class="row">
        <div id="tutorial-container" class="col-lg-9">
           <div class="main_title_2 ">
        <!-- <span><em></em></span> -->
        <h2>{{ tutorialInfo.Title }}</h2>
        <!-- <p>Cum doctus civibus efficiantur in imperdiet deterruisset.</p> -->
      </div>  
          <section id="description" class="p-3 bg_color_1">
           <p v-html="tutorialInfo.Body"></p>
          </section>
          <!-- /section -->
        </div>
        <!-- /col -->

        <aside class="col-lg-3" id="sidebar">
          <div class="box_detail booking bg_color_1">
            <div class="price ">
              <div class="">
                <span
                  >All Tutorials of</span
                > <br> <h4>{{ tutorialInfo.CategoryTitle }}</h4>
              </div>
            </div>
            <div class="mb-4">
              <ul v-if="tutoriallist.length > 0">
                <li
                  v-for="tutorial in tutoriallist"
                  :key="tutorial.Id"
                  :value="tutorial.Id"
                >
                <a href="javascript:void(0)" @click="reloadToDetailsPg(tutorial.Id)"> {{ tutorial.Title }}</a>
                  <!-- <router-link
                    :to="{
                      name: 'TutorialDetails',
                      params: { tutorialId: tutorial.Id },
                    }"
                  >
                    {{ tutorial.Title }}</router-link
                  > -->
                </li>
              </ul>
            </div>
            <router-link
              :to="{
                name: 'TutorialList'
              }"
              class="btn_1 full-width outline wishlist"
            >
              Back to List</router-link
            >
          </div>
        </aside>
      </div>
      <!-- /row -->
    </div>
    <!-- /container -->
  </div>
  <!-- /bg_color_1 -->
</template>
<script>
import TutorialService from '../services/tutorial-service'
export default {
  name: 'TutorialDetails',
  data() {
    return {
      tutorialInfo: [],
      tutoriallist: [],
    }
  },
  mounted() {
    this.fetchTutorialDetails(this.$route.params.tutorialId)
  },
  methods: {
    fetchTutorialDetails(Id) {
      this.tutorialInfo = []
      TutorialService.getTutorialDetailsbyId(Id).then((response) => {
        this.tutorialInfo = response.data.Object.tutorial
        this.getTutorials(this.tutorialInfo.CategoryId)
      }),
      (error) => {
        console.log(error)
      }
    },
    getTutorials(categoryId) {
      this.tutoriallist = []
      TutorialService.getFilteredTutorials(categoryId, 'null').then(
        (response) => {
          this.tutoriallist = response.data.Object.tutorials
        }
      )
    },
    reloadToDetailsPg(tutorialId){
      this.$router.push({ name: 'TutorialDetails', params: { tutorialId: tutorialId } }, )
      this.fetchTutorialDetails(tutorialId)
    }
  },
}
</script>
